import React from 'react'
import { DataTool, type DataToolProps } from '@ztechapps/webui.data-tools'
import { useWorkOrderListContext } from './Context'
import { workOrderListFieldConfig } from './constants'

export const WorkOrderListDataTool = ({ searchPlaceHolder, ...props }: DataToolProps) => {
  const { workOrderList, filterCategory } = useWorkOrderListContext()

  return (
    <DataTool
      filterCategory={filterCategory}
      fieldsConfig={workOrderListFieldConfig}
      onRefresh={workOrderList?.refetch}
      searchPlaceHolder={searchPlaceHolder ?? 'Search Work Orders'}
      {...workOrderList}
      {...props}
      onSort={null}
    />
  )
}
